export default __webpack_public_path__ + "static/media/gallery-image-5-full.f41f8a0d.jpg";